import { Injectable } from "@angular/core";
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { FrequenciesMockStore } from "src/app/shared/store-mocks/frequencies.store";
import { TimesMockStore } from "src/app/shared/store-mocks/times.store";



type State = {
    timeSelectorVisibility: boolean
}

const initialState: State = {
    timeSelectorVisibility: false
}

@Injectable()
export class CreateFormFrequencyTimeStore extends ComponentStore<State>{
    constructor(
        private timesMockStore: TimesMockStore,
    ){
        super({...initialState})
    }

    //selectors

    readonly entities$ = this.timesMockStore.viewEntities$

    readonly timeSelectorVisibility$ = this.select(state => state.timeSelectorVisibility)

    readonly vm$ = this.select(
        this.entities$,
        this.timeSelectorVisibility$,
        (entities, timeSelectorVisibility) => {
            return {
               entities,
               timeSelectorVisibility,
               value: ''
            }
        }, {debounce: true}
    )

    //updaters


    // effects

}
